import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {BackendService} from "../../services/backend.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {DebugService} from "../../debug/debug.service";

/**
 * global request id that can be injected by the backend.
 * @var string
 */
declare let advisorRequestId;

/**
 * Service for dealing with the backend and make request to the backend.
 */
@Injectable({
  providedIn: 'root'
})
export class ModeratBackendService extends BackendService {

  /**
   * @inheritdoc
   */
  requestIdName = 'moc-requestid';

  /**
   * @inheritdoc
   */
  backendDataEndpoint = '/moc/data/';

  /**
   * constructor.
   * @param http
   * @param backendService
   * @param debugService
   */
  constructor(protected http: HttpClient, private backendService: BackendService, protected debugService: DebugService) {
    super(http, debugService);

    // check if there is a request ID that should be injected
    if(typeof advisorRequestId === "string" && advisorRequestId.length > 0) {
      this.requestId = advisorRequestId;
      this.saveRequestId();
    }
  }

  /**
   * @inheritDoc
   * this is a small workaround so other components can still access the generic backendservice and will get the real advisor name
   * @param advisor
   */
  setAdvisor(advisor: string) {
    super.setAdvisor(advisor);

    this.backendService.setAdvisor(advisor);
  }

  /**
   * starts the calculation of the first chapter with the backend.
   * @param input
   * @param requestId
   * @param invoiceIndex
   */
  verbrauchsanalyse(input: any, requestId: string, invoiceIndex: number = null): Observable<any>{
    let url = '/moc/verbrauchsanalyse/' + requestId;
    if(invoiceIndex != null) {
      url += ('?invoice=' + invoiceIndex);
    }

    // add debug header to apicall
    const headers = new HttpHeaders({
      'x-api-debug': this.debugService.isDebugOn() ? '1' : '0'
    });

    return this.http.post(url, input, {headers}).pipe(
      tap(data => {
        if(data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }

  /**
   * starts the calculation the available measures
   * @param anfrage
   * @param requestId
   */
  massnahmen(anfrage: ModeratAnfrage, requestId: string): Observable<any>{
    const headers = new HttpHeaders({
      'x-api-debug': this.debugService.isDebugOn() ? '1' : '0'
    });

    return this.http.post('/moc/massnahmen/' + requestId, anfrage, {headers}).pipe(
      tap(data => {
        if(data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }
}
